
import DbModule from '../db';
import AppCheckModule from '../app-check';
import { CashierQueueDbTableRow } from './cashier.model';
import { getDocs, limit, orderBy, OrderByDirection, query, QueryConstraint, QueryDocumentSnapshot, startAfter, where, WhereFilterOp } from 'firebase/firestore/lite';
import { Pagination } from '../db/db.model';

export interface GetCashierQueueOrderBy {
    field: 'timestamp' | 'index';
    direction: OrderByDirection;
}
export interface GetCashierQueueFilterBy {
    field: 'tokenName' | 'sellerId' | 'sellerUsername' | 'sellerDisplayName' | 'status';
    opStr: WhereFilterOp;
    value: string | number;
}

export default class CashierService {
        private contractName: string;
    private domainName: string;
    private dbModule: DbModule;
    private appCheckModule: AppCheckModule;
    constructor(contractName: string, domainName: string, appCheckModule: AppCheckModule, dbModule: DbModule) {
        
        this.contractName = contractName;
        this.domainName = domainName;
        this.dbModule = dbModule;
        this.appCheckModule = appCheckModule;
    }

    async getCashierQueue(tokenName: string, _startAfter: QueryDocumentSnapshot<CashierQueueDbTableRow> | null, _limit: number, _filterBy?: GetCashierQueueFilterBy[], _orderBy?: GetCashierQueueOrderBy): Promise<Pagination<CashierQueueDbTableRow>> {
        const colRef = this.dbModule.getCollectionReference<CashierQueueDbTableRow>('Cashier');
        const queryConstraints: QueryConstraint[] = [where('tokenName', '==' , tokenName)];

        _filterBy?.forEach((filter): void => {
            const { field, opStr, value } = filter;
            queryConstraints.push(where(field, opStr, value));
        });

        if (_orderBy) // createdAt will be added in the end anyway
            queryConstraints.push(orderBy(_orderBy.field, _orderBy.direction));

        if (_startAfter)
            queryConstraints.push(startAfter(_startAfter));

        queryConstraints.push(limit(_limit));

        const q = query(colRef, ...queryConstraints);
        const querySnapshot = await getDocs(q);

        const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

        const data = this.dbModule.normalizeQuerySnapshot(querySnapshot);
        const items = Object.values(data);

        return { hasMore: items.length === _limit, items, lastDoc };

    }
}